import React, { useState } from "react";
import * as _ from "lodash";
import { IFormElement } from "../../Forms/interface/IFormElement";
import UILabel from "../Child/Label";
import { UIErrorOrNoteMessage } from "../Child/ErrorOrNote";
import { FILE_DOWNLOAD_API_URL } from "../../../../api/paths";
import { UIOutlineButton } from "../../../Buttons";
import { Axios } from "../../../../api/service/Axios";
import { CircularProgress } from "../../../Progress";

// Props type
type props = {
  formElement: IFormElement;
};

function isInfoMessage(formElement: IFormElement): boolean {
  if (_.isNull(formElement.value)) {
    return false;
  }
  if (!_.isObject(formElement.value)) {
    return false;
  }
  const ElementValue: any = formElement.value;
  if (_.isUndefined(ElementValue.info)) {
    return false;
  }
  return true;
}

const IsNotValidDownload = (formElement: IFormElement): boolean =>
  _.isNull(formElement.value) ||
  _.isEmpty(formElement.value) ||
  isInfoMessage(formElement);

// UIDownload Component
export const UIDownload = (props: props): JSX.Element => {
  const { formElement } = props;
  const [loader,setLoader] = useState<boolean>(false);

  let errorMessage = formElement.touched ? formElement.error : "";
  let disabled = formElement.disabled || formElement.read_only;
  if (!_.isEmpty(formElement.apiError)) {
    errorMessage = formElement.apiError;
    disabled = false;
  }

  let linkLabel = "";

  if (!_.isNull(formElement.value)) {
    linkLabel = formElement.value.title || "";
  }
  const onLinkClick = async (): Promise<void> => {
    if (IsNotValidDownload(formElement)) {
      return;
    }
    setLoader(true);
    const LinkUrl = formElement.value.url || "";
    const FileName = formElement.value.fileName || "";
    try {
      const responseFile = await Axios.getFile(`${process.env.REACT_APP_BASE_URL
        }${FILE_DOWNLOAD_API_URL}?filename=${FileName}&fileurl=${encodeURIComponent(
          LinkUrl
        )}`);
      const blob = new Blob([responseFile.data]);
      const downloadUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = FileName;
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      // error is handled silently; loader is reset in finally
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
    {loader && <CircularProgress></CircularProgress>}
      <UILabel formElement={formElement} />
      <UIOutlineButton
        isOutline={true}
        onClick={onLinkClick}
        disabled={IsNotValidDownload(formElement)}
        cssStyle={{
          textTransform: "none",
          fontWeight: 600,
        }}
        btnText={linkLabel || "Download"}
      />
      <UIErrorOrNoteMessage
        formElement={formElement}
        errorMessage={disabled ? "" : errorMessage}
      />
    </>
  );
};

export default UIDownload;
